import { render, staticRenderFns } from "./SnackAlert.vue?vue&type=template&id=5fa99978&"
import script from "./SnackAlert.vue?vue&type=script&lang=ts&"
export * from "./SnackAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports